import { render } from "./NcrmMailjetAutoSyncControl.vue?vue&type=template&id=a0bdb644&scoped=true"
import script from "./NcrmMailjetAutoSyncControl.vue?vue&type=script&lang=js"
export * from "./NcrmMailjetAutoSyncControl.vue?vue&type=script&lang=js"

import "./NcrmMailjetAutoSyncControl.vue?vue&type=style&index=0&id=a0bdb644&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0bdb644"]])

export default __exports__